import { render } from "./SurveyScreen.vue?vue&type=template&id=09c6d996"
import script from "./SurveyScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./SurveyScreen.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/SurveyScreen.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "09c6d996"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('09c6d996', __exports__)) {
    console.log('reload')
    api.reload('09c6d996', __exports__)
  }
  
  module.hot.accept("./SurveyScreen.vue?vue&type=template&id=09c6d996", () => {
    console.log('re-render')
    api.rerender('09c6d996', render)
  })

}


export default __exports__